import { RobotoDomainException } from "@/shared/http";

/**
 * Returns the devices whose request failed, in their original order, and each
 * failure's message keyed by device ID. `results` holds one settled request per
 * device, in the order of `devices`. A server refusal keeps its message, which
 * is written for the user; any other failure (a network error, a bug) gets
 * `fallback` instead of its raw text.
 */
export function collectDeviceFailures<T extends { device_id: string }>(
  devices: readonly T[],
  results: readonly PromiseSettledResult<unknown>[],
  fallback: string,
): { failed: T[]; messages: Map<string, string> } {
  const failed: T[] = [];
  const messages = new Map<string, string>();
  results.forEach((result, index) => {
    if (result.status === "rejected") {
      failed.push(devices[index]);
      messages.set(
        devices[index].device_id,
        result.reason instanceof RobotoDomainException &&
          result.reason.isClientError()
          ? result.reason.message
          : fallback,
      );
    }
  });
  return { failed, messages };
}
